import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MsjDescriptionPipe } from '../pipes/msj-description.pipe';
import { DialogComponent } from './dialog.component';
import { TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { DialogOptions } from '../models/dialogOptions.model';
const ACTION = 'Entendido';
@Injectable({
  providedIn: 'root'
})

export class MessageService {
  private config: MatSnackBarConfig;
  constructor(
    private snackBar: MatSnackBar,
    private msjpipe: MsjDescriptionPipe,
    private readonly bottomSheet: MatBottomSheet,
    private readonly transloco: TranslocoService) {
    this.config = new MatSnackBarConfig();
    this.config.duration = 5000;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showError(error: any, config = Object.assign(this.config)): void {
    const message = this.msjpipe.transform(error);
    const code = typeof error === 'string' ? error : error?.code;

    // Some successful/empty API responses are incorrectly surfaced as an
    // "OK" error by the legacy error path. Do not show that false toast.
    if (String(code || message).trim().toUpperCase() === 'OK') {
      return;
    }

    this.snackBar.open(message, ACTION, config);
  }

  showInfo(msj: string, extendDuration: boolean = false, _showConfirm: boolean  = false) {
    this.snackBar.open(msj, _showConfirm ? ACTION : '', extendDuration ? {
      duration: 15000 } : {});
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showOkCancel(msj: string, okAction?: string, cancelAction?: string): Observable<any> {
    const translatedMessage = this.transloco.translate(msj);
    const translatedOk = okAction ? this.transloco.translate(okAction) : 'Aceptar';
    const translatedCancel = cancelAction ? this.transloco.translate(cancelAction) : 'Cancelar';

    const sheetRef = this.bottomSheet.open(DialogComponent, {
      data: {
        message: translatedMessage,
        okAction: translatedOk,
        cancelAction: translatedCancel,
        option: DialogOptions.OkCancel
      }
    });

    return sheetRef.afterDismissed();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showYesNoCancel(msj: string, yesAction?: string, noAction?: string, cancelAction?: string): Observable<any> {
    const translatedMessage = this.transloco.translate(msj);
    const translatedYes = yesAction ? this.transloco.translate(yesAction) : 'Si';
    const translatedNo = noAction ? this.transloco.translate(noAction) : 'No';
    const translatedCancel = cancelAction ? this.transloco.translate(cancelAction) : 'Cancelar';

    const sheetRef = this.bottomSheet.open(DialogComponent, {
      data: {
        message: translatedMessage,
        okAction: translatedYes,
        noAction: translatedNo,
        cancelAction: translatedCancel,
        option: DialogOptions.YesNoCancel
      }
    });

    return sheetRef.afterDismissed();
  }
  close() {
    this.snackBar.dismiss();
  }
}
